//import Component
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { PrintQrcodeComponent } from './print-qrcode/print-qrcode.component';
import { UsersComponent } from './users/users.component';
import { DeviceComponent } from './device/device.component';
import { BoardComponent } from './board/board.component';
import { DeviceBoardComponent } from './device-board/device-board.component';
import { HistoryComponent } from './history/history.component';
import { VersionComponent } from './version/version.component';
import { LayoutPrintComponent } from './layout-print/layout-print.component';
import { LayoutPrintFormComponent } from './layout-print-form/layout-print-form.component';
import { AuthguardGuard } from "./authguard.guard";
import { AdminRoleGuard } from "./admin-role.guard";
import { PrintQrcodeSmallComponent } from "./print-qrcode-small/print-qrcode-small.component";
var routesConfig = [
    { path: 'login', component: LoginComponent, pathMatch: 'full' },
    { path: 'print-qrcode/:id', component: PrintQrcodeComponent },
    { path: 'print-qrcode-small/:id', component: PrintQrcodeSmallComponent },
    {
        path: '', canActivate: [AuthguardGuard], component: LayoutComponent,
        children: [
            { path: '', component: DashboardComponent },
            { path: 'qrcode', component: QrCodeComponent },
            { path: 'users', canActivate: [AdminRoleGuard], component: UsersComponent },
            { path: 'device', canActivate: [AdminRoleGuard], component: DeviceComponent },
            { path: 'board', canActivate: [AdminRoleGuard], component: BoardComponent },
            { path: 'device-board', canActivate: [AdminRoleGuard], component: DeviceBoardComponent },
            { path: 'history', canActivate: [AdminRoleGuard], component: HistoryComponent },
            { path: 'app-information', canActivate: [AdminRoleGuard], component: VersionComponent },
            { path: 'layout-print', children: [
                    { path: '', component: LayoutPrintComponent },
                    { path: ':id', component: LayoutPrintFormComponent }
                ] },
            { path: '**', component: DashboardComponent }
        ]
    },
];
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };



// WEBPACK FOOTER //
// /build/client-cms/src/app/app-routing.module.ts.pre-build-optimizer.js